/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Loading_VimeoInputs */



/**
* | output |
* | --- |
* | "Loading Vimeo Video..." |
*
* @param {Load_Project_File_Status_Loading_VimeoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_loading_vimeo = /** @type {((inputs?: Load_Project_File_Status_Loading_VimeoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Loading_VimeoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement de la video Vimeo...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vimeo-Video wird geladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento video Vimeo in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка видео с Vimeo...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando video de Vimeo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载 Vimeo 视频...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Vimeo ビデオを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Vimeo वीडियो लोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando vídeo do Vimeo...")
	return /** @type {LocalizedString} */ ("Loading Vimeo Video...")
});